<template>
  <div>
    <div v-if="hasData">
      <div v-for="report in reports" :key="report.fp_id">
        <q-list bordered padding v-if="activeFingerPrint != report.id">
          <q-item tag="label" v-ripple @click="setActiveFingerPrint(report.id)">
            <q-item-section>
              <q-item-label>ชื่อผู้สแกนลายนิ้วมือ</q-item-label>
            </q-item-section>
            <q-item-section side> {{ report.fingerprint_name }} </q-item-section>
          </q-item>
        </q-list>

        <q-list bordered padding v-else>
          <!-- <q-item-label header>Notifications</q-item-label> -->
          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>ชื่อผู้สแกนลายนิ้วมือ</q-item-label>
            </q-item-section>
            <q-item-section side> {{ report.fingerprint_name }} </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>เลขที่สัญญา</q-item-label>
            </q-item-section>
            <q-item-section side> {{ report.contract_no }} </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>เลขรายงาน</q-item-label>
            </q-item-section>
            <q-item-section side> {{ report.report_no }} </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>รายงานสถานะ</q-item-label>
            </q-item-section>
            <q-item-section side> {{ report.report_status }} </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>วันที่ส่งข้อมูล Report</q-item-label>
            </q-item-section>
            <q-item-section side> {{ formatDate(report.reported_at) }} </q-item-section>
          </q-item>
        </q-list>
      </div>
      </div>
      <div v-else>
        <q-banner class="bg-grey-3">
          <template v-slot:avatar>
            <q-icon name="error_outline" color="primary" />
          </template>
          No data
        </q-banner>
      </div>
  </div>

</template>

<script>
import { Loading } from 'quasar'
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
export default {
  data () {
    return {
      activeFingerPrint: 1,
      hasData: true,
      reports: [
        {
          id: 0,
          fp_id: 0,
          contract_no: '',
          fingerprint_name: '',
          report_no: '',
          report_status: '',
          scaned_at: '',
          reported_at: ''
        }
      ]
    }
  },
  methods: {
    ...mapActions('auth', ['handleLogin', 'setActiveRoute', 'setForbidden']),
    firstFingerPrint () {
      this.setActiveFingerPrint(this.reports[0].id)
    },
    setActiveFingerPrint (fpId) {
      this.activeFingerPrint = fpId
    },
    formatDate (dt) {
      if (dt !== null && dt.length > 9) {
        const datetime = new Date(dt)
        return `${datetime.getDate()}/${(datetime.getMonth() + 1)}/${datetime.getFullYear()}`
      } else {
        return '-'
      }
    }
  },
  computed: {
    ...mapState('auth', ['apiToken'])
  },
  mounted () {
    Loading.show()
    this.setActiveRoute('report')
    this.handleLogin()

    const token = this.apiToken
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    }
    axios.get(`${process.env.VUE_APP_API}api/fingerprints`, config)
      .then((res) => {
        // console.log(res)
        Loading.hide()
        if (res.data != null) {
          // console.log(res.data)
          if (res.data.length > 0) {
            this.reports = res.data
            this.firstFingerPrint()
            this.hasData = true
          } else {
            this.hasData = false
            console.log('Empty')
          }
        }
      })
      .catch(e => {
        Loading.hide()
        this.setForbidden()
        // console.log(e.toJSON())
        // if (e.response.status === 401) {
        // console.log(e.response.status)
        this.$router.push('/register', () => {})
        // }
      })
  }
}
</script>
